import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
import useDimensionCredits from './use-user-dimension-credits'
import SpinnerContainer from '../../common/spinner-container'
import hooks from '../../../hooks'

const axisBottom = {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'Student',
    legendPosition: 'middle',
    legendOffset: 32
}

const axisLeft = {
    tickSize: 5,
    tickPadding: 5,
    tickRotation: 0,
    legend: 'Units',
    legendPosition: 'middle',
    legendOffset: -40
}

const legend = {
    dataFrom: 'keys',
    anchor: 'right',
    direction: 'column',
    justify: false,
    translateX: 120,
    translateY: 0,
    itemsSpacing: 2,
    itemWidth: 100,
    itemHeight: 20,
    itemDirection: 'left-to-right',
    itemOpacity: 0.85,
    symbolSize: 20,

}

const DimensionsBarGraph = ({
    userId,
}) => {
    const {
        isLoadingDimensionCredits,
        semesters,
        maxCreditsPerSemester,
        keys,
        colors
    } = useDimensionCredits({ userId })

    const { isLoadingSystemSettings, semesterDimensionRequirement, progressTitle } = hooks.useSystemSettings()

    if (isLoadingDimensionCredits || isLoadingSystemSettings) {
        return (
            <SpinnerContainer label="Loading Progress..." />
        )
    }

    const getColor = (key) => colors[key.id]
    const maxHeight = Math.max(maxCreditsPerSemester, semesterDimensionRequirement || 15)
    axisBottom.legend = progressTitle

    return (
        <div
            style={{
                height: '100%'
            }}
        >
            <ResponsiveBar
                data={semesters}
                maxValue={maxHeight}
                keys={keys}
                indexBy="label"
                margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                padding={0}
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                axisLeft={axisLeft}
                axisBottom={axisBottom}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                legends={[legend]}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                colors={getColor}
            />
        </div>  
    )
}

export default DimensionsBarGraph